<template>
  <div>
    <span v-if="problemStatus[value]">
      <a-dropdown :trigger="['click']">
        <span class="edit-status">
          <a-tag :color="problemStatus[value].color">{{ problemStatus[value].label }}</a-tag>
          <a-icon class="icon-down" type="down" />
        </span>
        <a-menu slot="overlay">
          <a-menu-item v-for="(item, index) in nextStatus" :key="index" @click="onChange(item)">
            <a-tag :color="problemStatus[item].color">{{ problemStatus[item].label }}</a-tag>
          </a-menu-item>
        </a-menu>
      </a-dropdown>
    </span>
    <a-modal v-model="visible" width="820px" title="状态变更" @ok="onSubmit" @cancel="onClose('cancel')">
      <a-form-model ref="form" :model="form" :rules="rules" :label-col="labelCol" :wrapper-col="wrapperCol">
        <a-form-model-item v-if="problemStatus[form.after_status]" label="变更">
          <a-tag :color="problemStatus[value].color">{{ problemStatus[value].label }}</a-tag>
          <a-icon type="double-right" />
          <a-tag :color="problemStatus[form.after_status].color" style="margin-left: 8px">{{ problemStatus[form.after_status].label }}</a-tag>
        </a-form-model-item>
        <a-form-model-item label="描述" prop="comment">
          <vditor-editor v-model="form.comment" :height="200" />
        </a-form-model-item>
      </a-form-model>
    </a-modal>
  </div>
</template>
<script>
import VditorEditor from '@/components/VditorEditor';
import { problemStatus } from '@/utils/dictionary';
import { problemStatusUpdate } from '@/api/event/problem';

export default {
  components: { VditorEditor },
  props: {
    sourceId: {
      type: [String, Number],
      default: null
    },
    sourceValue: {
      type: [String, Number],
      default: null
    },
    statusFlow: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {
      labelCol: { span: 2 },
      wrapperCol: { span: 21 },
      problemStatus,
      visible: false,
      value: null,
      form: {
        after_status: null,
        comment: '  '
      },
      rules: {}
    };
  },
  computed: {
    nextStatus() {
      return [...this.statusFlow.child_node, ...this.statusFlow.turn_down_node].map(item => item.node_id);
    }
  },
  watch: {
    sourceValue() {
      this.value = this.sourceValue;
    }
  },
  mounted() {
    this.value = this.sourceValue;
  },
  methods: {
    onChange(value) {
      this.form = {
        after_status: value,
        comment: ''
      };
      this.visible = true;
    },

    onSubmit() {
      problemStatusUpdate({ ...this.form, id: this.sourceId }).then(() => {
        this.$message.success('状态更新成功');
        this.$emit('change');
        this.visible = false;
        this.value = this.form.after_status;
      });
    }
  }
};
</script>

<style lang="less" scoped>
.edit-status {
  cursor: pointer;
  display: inline-block;
  padding: 0 4px;
  line-height: 22px;
  .icon-down {
    opacity: 0;
  }
}
.edit-status:hover {
  cursor: pointer;
  background-color: #e4e4e4;
  .icon-down {
    opacity: 1;
  }
}
</style>
